import { celebrateAction, feedbackKindFor, shouldCelebrate } from './celebration';
import { MutationCache } from '@tanstack/react-query';
import { useToastStore } from '@/stores/toast.store';

// All user mutations get feedback by default. Read-only previews and redirects opt out.
export function createActionMutationCache() {
  return new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      const completed = shouldCelebrate(mutation.meta, _variables);
      if (completed) celebrateAction(mutation.meta);
      const message = mutation.meta?.['successMessage'];
      if (message === false) return;
      useToastStore
        .getState()
        .push(
          typeof message === 'string' ? message : 'Changes saved',
          'success',
          completed ? feedbackKindFor(mutation.meta) : undefined,
        );
    },
    onError: (error, _variables, _context, mutation) => {
      // Recoverable forms/queues own durable inline errors, including clearing them on retry.
      if (mutation.meta?.['errorMessage'] === false) return;
      useToastStore
        .getState()
        .push(
          error instanceof Error
            ? error.message
            : 'Could not complete the action. Please try again.',
          'error',
        );
    },
  });
}
